import React from "react";

import { Html } from "../../../html";
import { Image } from "../../../image";
import { Accordion } from "../../../accordion";

import styles from "./styles.modules.scss";

export const BlockFeature = ({
    body,
    image,
    position,
    title,
    accordion,
}: InboxArticleFeatureBlock) => {
    const hasBody = !!body;

    const content = (
        <div
            className={`block-feature ${styles.blockFeature} ${
                position === "right" ? `${styles.right} right` : "left"
            }`}
        >
            {image && (
                <div className={`image ${styles.image}`}>
                    <Image sources={image} cover />
                </div>
            )}

            <div
                className={`content ${styles.content} ${
                    hasBody ? "" : styles["no-body"]
                }`}
            >
                {accordion !== "yes" && (
                    <div className={`title ${styles.title}`}>{title}</div>
                )}

                {hasBody && <Html html={body} />}
            </div>
        </div>
    );

    return accordion === "yes" ? (
        <Accordion title={title} body={content} />
    ) : (
        content
    );
};
